// extracted by mini-css-extract-plugin
export default {"container":"ChangePassword_container__XRVjx","text_small":"ChangePassword_text_small__VDQBY"};